const FontMime = (mime) => {
  switch (mime) {
    case 'ttf':
      return 'truetype';
    case 'otf':
      return 'opentype';
    case 'woff':
      return 'woff';
    case 'woff2':
      return 'woff2';
    default:
      break;
  }
};

export default FontMime;